// The "state" is basically a CSRF token.
// When redirecting to Cognito, we store the state in localStorage, and then we verify
// that what gets sent back from Cognito matches.

import * as Uuid from 'uuid'

const stateKey = 'cognito-state'

export default class CognitoState {
  public static create() {
    const state = Uuid.v4()
    localStorage.setItem(stateKey, state)
    return state
  }

  public static get value() {
    const output = localStorage.getItem(stateKey)
    if (output === null) {
      throw new Error(
        'Attempted to retrieve CognitoState.value without first calling CognitoState.create().'
      )
    }
    return output
  }

  public static validate(state: string | null) {
    if (!state) {
      throw new Error(`Cognito did not return a CSRF token.`)
    }
    const expected = localStorage.getItem(stateKey)
    if (!expected) {
      throw new Error(`Could not find original CSRF token to compare to "${state}".`)
    }
    if (state !== expected) {
      throw new Error(
        `CSRF token "${state}" returned from Cognito did not match the value we sent: "${expected}". Cross-site request forgery suspected.`
      )
    }
    return true
  }
}
